<template>
    <div>
        <h1 class="mt-16 flex w-full justify-center text-xl md:text-3xl font-semibold text-ihh-midnight-gray pb-5">Oops! We've run into an error</h1>
        <div class="flex justify-center mt-10 mb-12">
            <div class="w-2/3">
                Your account has not been created. Please try again and if this issue persists, contact <a href="mailto:support@inhishands.com" class="underline text-blue-600 hover:font-bold ">support@inhishands.com</a>.
            </div>
        </div>
        <div class="flex justify-center w-full text-black">
            <div class="bg-gradient-to-b from-ihh-pink to-ihh-purple p-6 rounded shadow w-1/2">
                <div class="w-full flex justify-center">
                    <span>Support Diagnostics</span>
                </div>
                <div>
                    <span class="font-bold">Error:</span>
                    <p>{{ error }}</p>
                </div>
            </div>
        </div>
        <div class="flex justify-center mt-12">
            <router-link to="/sign-up">
                <button class=" mt-6 mb-24 ext-sm md:text-base text-ihh-midnight-gray py-3 px-8 rounded-lg bg-ihh-dark-salmon hover:bg-ihh-salmon delay-100 transition tracking-wide">Create Account</button>
            </router-link>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            email: 'email',
        }
    },
    props: ['error'],
}
</script>

<style>

</style>
